import React, {useState, useEffect, useRef} from 'react'

// Deps
import {connect} from 'react-redux';
// import config from 'config'

// Partials
import Image from 'views/shared/partials/image'
import Link from 'views/shared/partials/link'

// Utils
import {openModal} from 'utils/modals';

// Services
// import userServices from 'services/user'

// Static Assets
import Logo from 'assets/images/shared/logo-light.svg'

const mapStateToProps = (state, ownProps) => {
    return {
        mobileState: state.site.mobile,
        currentPage: state.site.currentPage,
        userData: state.user.data,
    };
};

const Sidebar = ({userData, ...props}) => {
    const [active, setActive] = useState(false);
    const [show, setShow] = useState(false);

    const toggleTimer = useRef(false);

    useEffect(() => {
        if (toggleTimer.current) {
            clearTimeout(toggleTimer.current);
        }

        if (props.open) {
            setActive(true);
            toggleTimer.current = setTimeout(() => {
                setShow(true);
                toggleTimer.current = false;
            }, 30)
        } else {
            setShow(false);
            toggleTimer.current = setTimeout(() => {
                setActive(false);
                toggleTimer.current = false;
            }, 410)
        }
    }, [props.open])

    const checkActiveLink = (keys) => {
        if (typeof (keys) === 'string' && keys === props.currentPage.key) {
            return ' active';
        } else if (keys.includes(props.currentPage.key)) {
            return ' active';
        } else {
            return '';
        }
    }

    const bgClick = (e) => {
        if (e.target.classList.contains('sidebar')) {
            props.onClose();
        }
    }

    return (
        <aside
            className={'section sidebar' + (active ? ' active' : '') + (show ? ' show' : '')}
            onClick={bgClick}>
            <div className="sidebar-container">
                <div className="sidebar-header">
                    {props.mobileState ?
                        <button className="header-closebtn" onClick={props.onClose}>
                            <i className="icon-close"></i>
                        </button>
                        :
                        <Link
                            className="header-logo"
                            href="dashboard">
                            <Image
                                className="logo-image"
                                src={Logo}/>
                        </Link>
                    }
                </div>
                <ul className="sidebar-menu">
                    <li className="menu-item dashboard">
                        <Link
                            href="dashboard"
                            className={'item-link' + checkActiveLink('dashboard')}>
                            <span>Dashboard</span>
                            <i className="icon-dashboard"></i>
                        </Link>
                    </li>
                    {(userData && userData.is_owner) &&
                    <li className="menu-item settings">
                        <Submenu
                            open={props.currentPage.group === 'settings'}
                            title="Ayarlar"
                            icon="settings">
                            <li className="menu-item settings-companyinfo">
                                <Link
                                    href="settings.companyInfo"
                                    className={'item-link' + checkActiveLink('companyInfo')}>
                                    <span>Firma Bilgileri</span>
                                    <i className="icon-card"></i>
                                </Link>
                            </li>
                            <li className="menu-item settings-companypaymenttypes">
                                <Link
                                    href="settings.companyPaymentTypes"
                                    className={'item-link' + checkActiveLink(['companyPaymentTypes', 'companyPaymentTypeDetail'])}>
                                    <span>Ödeme Ayarları</span>
                                    <i className="icon-cards"></i>
                                </Link>
                            </li>
                            <li className="menu-item settings-groups">
                                <Link
                                    href="settings.groups"
                                    className={'item-link' + checkActiveLink(['groups', 'groupDetail'])}>
                                    <span>Gruplar</span>
                                    <i className="icon-users"></i>
                                </Link>
                            </li>
                            <li className="menu-item settings-accounts">
                                <Link
                                    href="settings.accounts"
                                    className={'item-link' + checkActiveLink(['accounts', 'accountDetail'])}>
                                    <span>Kullanıcılar</span>
                                    <i className="icon-user"></i>
                                </Link>
                            </li>
                            <li className="menu-item settings-costreports">
                                <Link
                                    href="settings.costReports"
                                    className={'item-link' + checkActiveLink('costReports')}>
                                    <span>Kullanım Raporları</span>
                                    <i className="icon-report"></i>
                                </Link>
                            </li>
                            <li className="menu-item settings-balancereports">
                                <Link
                                    href="settings.balanceReports"
                                    className={'item-link' + checkActiveLink('balanceReports')}>
                                    <span>Bakiye Özeti</span>
                                    <i className="icon-card"></i>
                                </Link>
                            </li>
                            <li className="menu-item settings-productsettings">
                                <Link
                                    href="settings.productSettings"
                                    className={'item-link' + checkActiveLink('productSettings')}>
                                    <span>Ürün Entegrasyonu</span>
                                    <i className="icon-product"></i>
                                </Link>
                            </li>
                            <li className="menu-item settings-announcements">
                                <Link
                                    href="settings.announcements"
                                    className={'item-link' + checkActiveLink('announcements')}>
                                    <span>Duyurular</span>
                                    <i className="icon-notification"></i>
                                </Link>
                            </li>
                        </Submenu>
                    </li>
                    }
                    {userData.company.product_terminal_status !== 2 && (
                        <li className="menu-item clients">
                            <Link
                                href="clients"
                                className={'item-link' + checkActiveLink(['clients', 'clientDetail'])}>
                                <span>Müşteriler</span>
                                <i className="icon-users"></i>
                            </Link>
                        </li>
                    )}
                    {(userData && userData.company.product_terminal_status !== 0) &&
                    <>
                        <li className="menu-item products">
                            <Link
                                href="products"
                                className={'item-link' + checkActiveLink(['products'])}>
                                <span>Ürünler</span>
                                <i className="icon-product"></i>
                            </Link>
                        </li>
                        <li className="menu-item commerceOrders">
                            <Link
                                href="commerceOrders"
                                className={'item-link' + checkActiveLink(['commerceOrders', 'commerceOrderDetail'])}>
                                <span>Siparişler</span>
                                <i className="icon-products"></i>
                            </Link>
                        </li>
                    </>
                    }

                    {userData.company.product_terminal_status !== 2 && (
                        <>
                            <li className="menu-item orders">
                                <Link
                                    href="orders"
                                    className={'item-link' + checkActiveLink(['orders', 'orderDetail'])}>
                                    <span>Ödeme Talepleri</span>
                                    <i className="icon-payment"></i>
                                </Link>
                            </li>
                            <li className="menu-item orderplans">
                                <Link
                                    href="orderPlans"
                                    className={'item-link' + checkActiveLink(['orderPlans', 'orderPlanDetail'])}>
                                    <span>Ödeme Planları</span>
                                    <i className="icon-time"></i>
                                </Link>
                            </li>
                            <li className="menu-item ordertemplates">
                                <Link
                                    href="orderTemplates"
                                    className={'item-link' + checkActiveLink(['orderTemplates', 'orderTemplateDetail'])}>
                                    <span>Hazır Ödeme Şablonları</span>
                                    <i className="icon-payment"></i>
                                </Link>
                            </li>
                            <li className="menu-item payments">
                                <Link
                                    href="payments"
                                    className={'item-link' + checkActiveLink(['payments', 'paymentDetail'])}>
                                    <span>Ödemeler</span>
                                    <i className="icon-report"></i>
                                </Link>
                            </li>
                        </>
                    )}
                    <li className="menu-item quickmenu">
                        <Submenu
                            title="Hızlı Erişim"
                            icon="star-empty">
                            {userData.company.product_terminal_status !== 2 && (
                                <>

                                    <li className="menu-item quickmenu-createorder">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                openModal('create-order');
                                            }}
                                            className="item-link">
                                            <span>Yeni Ödeme Oluştur</span>
                                            <i className="icon-card"></i>
                                        </button>
                                    </li>
                                    <li className="menu-item quickmenu-createorder">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                openModal('create-order', {expressOrder: true});
                                            }}
                                            className="item-link">
                                            <span>Hızlı Ödeme Gerçekleştir</span>
                                            <i className="icon-payment"></i>
                                        </button>
                                    </li>
                                    <li className="menu-item quickmenu-createclient">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                openModal('client');
                                            }}
                                            className="item-link">
                                            <span>Yeni Müşteri Oluştur</span>
                                            <i className="icon-user"></i>
                                        </button>
                                    </li>
                                </>
                            )}
                            <li className="menu-item quickmenu-terminal">
                                <Link
                                    href="/terminal/dashboard"
                                    className="item-link">
                                    <span>Terminal Görünümü</span>
                                    <i className="icon-calculator"></i>
                                </Link>
                            </li>
                        </Submenu>
                    </li>
                </ul>
            </div>
        </aside>
    )
}

const Submenu = ({title, icon, children, ...props}) => {
    const [open, setOpen] = useState(props.open);

    useEffect(() => {
        if (props.open) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [props.open]);

    return (
        <React.Fragment>
            <button
                type="button"
                onClick={() => {
                    setOpen(!open);
                }}
                className="item-link">
                <span>{title}</span>
                <i className={'icon-' + icon}></i>
            </button>

            {open &&
            <ul className="item-submenu">
                {children}
            </ul>
            }
        </React.Fragment>
    )
}

Submenu.defaultProps = {
    open: false,
}

export default connect(mapStateToProps)(Sidebar);